<!--
 Terms Facet Component
 Shows available shop terms for given search input
 devs@droxit.de
 Copyright (c) 2022 droxIT GmbH
-->

<template>
  <b-container class="facet" fluid="md" v-if="showFacet">
    <b-row class="facet-title">
      <b-col>
        {{ facet.label }}
      </b-col>
    </b-row>
    <b-row class="facet-terms">
      <b-col>
        <b-form-checkbox-group
          :id="facet.name + '_checkbox'"
          v-model="selected"
          :name="facet.name"
        >
          <div class="facet-term-option" v-for="term in facet.options" :key="term.value">
            <b-form-checkbox   :value="term.value">
              {{ term.value }} ({{ term.num }})
            </b-form-checkbox>
          </div>
        </b-form-checkbox-group>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  export default {
    name: 'TermsFacetComputer',
    props: {
      facet: Object,
      filter: Array
    },
    data: function(){
      return {
         selected: this.filter || []
      }
    },
    watch: {
      selected: function(options){
        this.setFilter(options)
      }
    },
    computed: {
      showFacet: function(){
        return this.facet.options.length > 0;
      }
    },
    methods: {
      setFilter: function (selected) {
        this.$root.$emit('RocketFilterSelectedEvent', { name: this.facet.name, options: selected });
      }
    }
  }
</script>
